var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6933 15.9818C12.6933 15.7278 12.6933 15.5283 12.6933 15.3106C12.6933 13.5873 12.6933 11.8639 12.6755 10.1224C12.6755 9.7233 12.5866 9.30607 12.4799 8.92512C12.3199 8.41718 11.9466 8.12693 11.4311 8.01809C11.0399 7.94553 10.6311 7.94553 10.2577 8.07251C9.70662 8.23577 9.33328 8.61673 9.20884 9.17909C9.10217 9.61446 9.03106 10.068 9.03106 10.5033C9.01328 12.1541 9.03106 13.8049 9.01328 15.4739C9.01328 15.619 9.01328 15.7641 9.01328 15.8911C8.69328 15.9999 6.45328 16.0362 5.77773 15.9455C5.68884 15.6371 5.6355 6.24031 5.72439 5.3877C6.02661 5.26072 8.17773 5.24258 8.81773 5.35142C8.94217 5.75051 8.8355 6.18589 8.90661 6.67568C8.97773 6.60312 9.03106 6.58498 9.04884 6.53056C9.93773 5.33328 11.1644 4.93419 12.5866 5.04303C13.0844 5.07931 13.5644 5.18815 14.0266 5.40584C14.6844 5.69609 15.1644 6.16775 15.4666 6.82081C15.8577 7.63713 15.9999 8.50788 15.9999 9.39677C15.9999 11.5011 15.9999 13.5873 15.9999 15.6734C15.9999 15.7641 15.9822 15.8367 15.9644 15.9818C14.8977 16.0181 13.8133 15.9999 12.6933 15.9818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57335 5.31521C3.57335 8.8889 3.57335 12.39 3.57335 15.9093C3.27113 16 1.04891 16.0363 0.355576 15.9456C0.248909 15.6372 0.213353 6.02269 0.32002 5.29706C1.36891 5.27892 2.45335 5.29706 3.57335 5.31521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84 1.90476C3.85778 2.93878 2.98667 3.8458 1.93778 3.86395C0.871111 3.88209 0 3.01134 0 1.9229C0 0.870748 0.853333 0 1.92 0C2.96889 0 3.82222 0.852608 3.84 1.90476Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f1e389e08ec3f0293372943f75e5f65c.svg";
export { ForwardRef as ReactComponent };